/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreatedWellInfo,
  WellBrief,
  WellCreation,
  WellHead,
  WellInfo,
  WellKsuIdMapping,
  WellLinkedDataType,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class WellsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Wells
   * @summary Получение идентификаторов скважин, принадлежащих месторождению
   * @request GET:/geology/Wells/for_field/{fieldId}
   * @secure
   */
  wellsGetWellIdsForField = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Wells/for_field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Получение скважин, принадлежащих месторождению
   * @request GET:/geology/Wells/for_field/{fieldId}/data
   * @secure
   */
  wellsGetWellsForField = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<WellInfo[], any>({
      path: `/geology/Wells/for_field/${fieldId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Получение скважин по месторождению, на которых имеются данные определенного вида.
   * @request GET:/geology/Wells/for_field/{fieldId}/having/{linkedDataType}
   * @secure
   */
  wellsGetWellsHavingDataForField = (
    fieldId: string,
    linkedDataType: WellLinkedDataType,
    params: RequestParams = {},
  ) =>
    this.http.request<WellBrief[], any>({
      path: `/geology/Wells/for_field/${fieldId}/having/${linkedDataType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Получение информации о скважине по идентификатору
   * @request GET:/geology/Wells/{id}
   * @secure
   */
  wellsGetWellDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<WellInfo, any>({
      path: `/geology/Wells/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Получение сопоставления идентификаторов скважин наших и КСУ НСИ по списку наших id скважин
   * @request POST:/geology/Wells/ksu-mapping
   * @secure
   */
  wellsGetKsuIdMapping = (data: string[], params: RequestParams = {}) =>
    this.http.request<WellKsuIdMapping[], any>({
      path: `/geology/Wells/ksu-mapping`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Установка устьевых координат скважин (из ГеоБД)
   * @request PUT:/geology/Wells/wellheads
   * @secure
   */
  wellsUpdateWellHeads = (data: WellHead[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/geology/Wells/wellheads`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Создаёт скважины.
   * @request POST:/geology/Wells
   * @secure
   */
  wellsCreateWells = (data: WellCreation[], params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Wells`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Wells
   * @summary Создаёт скважины.
   * @request POST:/geology/Wells/with_results
   * @secure
   */
  wellsCreateWellsWithResults = (data: WellCreation[], params: RequestParams = {}) =>
    this.http.request<CreatedWellInfo[], any>({
      path: `/geology/Wells/with_results`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
